import { render } from "./PrintTermsBlock.vue?vue&type=template&id=18d99f7d&scoped=true"
import script from "./PrintTermsBlock.vue?vue&type=script&lang=js"
export * from "./PrintTermsBlock.vue?vue&type=script&lang=js"

import "./PrintTermsBlock.vue?vue&type=style&index=0&id=18d99f7d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d99f7d"]])

export default __exports__